/**
 * вычисление кол-ва карточек в строке
 * @returns {number}
 */
function getNumberCardsInLine() {
    if (window.innerWidth > 1200) {
        return 3;
    }
    if (window.innerWidth >= 768) {
        return 2;
    }
    return 1;
}

export default function newsCard() {
    const cards = document.querySelectorAll('.js-news-card');
    if (!cards) { return false; }
    const numberCardsLine = getNumberCardsInLine();
    const numberAllCards = cards.length;

    if (numberAllCards > numberCardsLine) {
        let remainder = numberAllCards % numberCardsLine; // остаток
        if (remainder === 0) { remainder = numberCardsLine; }
        for (let i = 1; i <= remainder; i++) {
            cards[numberAllCards - i].classList.add('is-last');
        }
    }
}
